import React from "react";
import _ from "lodash";
import { useI18n } from "Hooks";
import {
  getFormattedNameForUserType,
  getMessageTimeSinceText,
  getSubText,
  CHAT_TYPES,
} from "MessagingV2/modules/Utils";
import {
  getUserType,
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";

import { connect } from "react-redux";

import Thread from "../../Thread/Thread";

const AvailableChatSuggestion = props => {
  const { t } = useI18n();

  const {
    onThreadClick,
    defaultStudentNameSortPreference,
    defaultStudentNameOrderPreference,
  } = props;

  const chats = _.get(props, "chats", []);

  return _.map(chats, node => {
    const {
      id,
      isMuted,
      lastActiveAt,
      unreadMessageCount,
      type,
      label,
      isArchived,
      profileImageData = {},
      personalChatReceiverUser: messagedUser = {},
      totalUsersCount,
    } = node;

    const isPersonalChat = _.isEqual(type, CHAT_TYPES.CHAT_PERSONAL);

    const profileImage = _.get(messagedUser, "profileImage", "");

    const mainText = isPersonalChat
      ? getFormattedNameForUserType({
          user: messagedUser,
          orderBy: defaultStudentNameSortPreference,
          defaultStudentNameOrderPreference,
          isFormattedNameV2: true,
        })
      : label;

    const subText = isPersonalChat
      ? getSubText({
          loggedInUserRole: getUserType(),
          messagedUserObj: messagedUser,
          messagedUserRole: _.get(messagedUser, "type"),
          t,
          defaultStudentNameSortPreference,
        })
      : t("common:count_members", {
          count: totalUsersCount,
        });

    return (
      <Thread
        id={id}
        avatarId={_.get(messagedUser, "id")}
        key={id}
        chatType={type}
        isMainTextHighlighted={unreadMessageCount > 0 && !isMuted}
        mainText={mainText}
        subText={subText}
        unreadMessageCount={unreadMessageCount}
        timeSinceLastMessage={getMessageTimeSinceText(lastActiveAt, t)}
        isChatMuted={isMuted}
        isArchived={
          isPersonalChat ? _.get(messagedUser, "isArchived") : isArchived
        }
        onlineStatus={false}
        onThreadClick={onThreadClick}
        profileIcon={profileImageData?.icon}
        profileImage={isPersonalChat ? profileImage : profileImageData?.url}
        userId={_.get(messagedUser, "id")}
        alertTypes={
          messagedUser?.type === "student"
            ? _.get(messagedUser, "alertTypes", [])
            : undefined
        }
      />
    );
  });
};

const mapStateToProps = state => {
  const defaultStudentNameSortPreference = getDefaultNameSortPreference(state);
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  return {
    defaultStudentNameSortPreference,
    defaultStudentNameOrderPreference,
  };
};

export default connect(mapStateToProps)(AvailableChatSuggestion);
